/** Создает строку для window.Telegram.WebApp.initDataUnsafe.start_param */
export const composeStartParam = (
  referralKey: string | null,
  boxId: number | null,
) => {
  if (referralKey && boxId !== null) {
    return `ref_${referralKey}_box_${boxId}`
  }
  if (referralKey) {
    return `ref_${referralKey}`
  }
  if (boxId !== null) {
    return `box_${boxId}`
  }
  return ''
}

/** Парсит строку из window.Telegram.WebApp.initDataUnsafe.start_param */
export const parseStartParam = (param: string | undefined) => {
  if (!param) return { ref: null, box: null }

  try {
    // Формат: ref_XXX_box_YYY, ref_XXX, или box_YYY
    let ref: string | null = null
    let box: string | null = null

    // Проверяем наличие referral key
    if (param.includes('ref_')) {
      // Извлекаем ref: либо между 'ref_' и '_box_', либо до конца строки
      const refMatch = param.match(/ref_([^_]+)(?:_box_|$)/)
      ref = refMatch ? refMatch[1] : null
    }

    // Извлекаем box после 'box_'
    const boxMatch = param.match(/box_(\d+)/)
    box = boxMatch ? boxMatch[1] : null

    return {
      ref,
      box,
    }
  } catch (error) {
    throw new Error(`Failed to parse start parameter: ${error}`)
  }
}
